module.exports = __webpack_public_path__ + "img/1.90ab45d0.png";